<template>
    <div>
        <h4>Pull List</h4>
        <div v-for="(item, index) in items" :key="index">
            <b-row>
                <b-col>
                    <print-item :item="item"></print-item>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import PrintItem from "./PrintItem";

    export default {
        name: "PrintList",
        props: [ 'items' ],
        components: { PrintItem },
    }
</script>

<style scoped>

</style>